import React from 'react';
import './AboutPrescription.scss';
import { Icon } from '../../../components/ui/index';

const AboutPrescription = () => {
  return (
    <>
      <div id="frame-and-lenses-step" className="about-step active">
        <div className="step-section section1">
          <div className="wrapper">
            <div className="column left">
              <Icon imgPath="/images/about/about-prescription-role-step2.png"></Icon>
            </div>
            <div className="column right">
              <h2>The prescription’s role</h2>
              <p>
                An optical advice is the prescription written by a professional such as an
                ophthalmologist (in France) or an optometrist (in Anglo-Saxon countries), which
                indicates the value of all the parameters necessary to create your equipement of
                corrective lenses.
              </p>
              <p>
                <span className="bold">
                  It allows us to make your glasses the closest to your visual needs.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="prescription-step step-section section2">
        <div className="wrapper">
          <div className="column left">
            <h2>How to read your prescription</h2>
            <p>
              An ophthalmic prescription is to correct the ametropia, that is to say, one or several
              defects that your eyes may have: myopia, hyperopia, astigmatism and presbyopia. Often
              both eyes do not have the same correction and require different lenses.
            </p>
            <p>
              Depending on your refraction, the data on your prescription can vary. Here are the
              main abbreviations to help you in completing our online form and order your glasses in
              a few clicks.
            </p>
          </div>
          <div className="column right">
            <Icon imgPath="/images/about/about-prescription-read-step2.png"></Icon>
            <ul className="right">
              <li>
                <p>
                  <span className="bold">- RE : </span>Right eye
                </p>
              </li>
              <li>
                <p>
                  <span className="bold">- LE : </span>Left eye
                </p>
              </li>
              <li>
                <p>
                  <span className="bold">- RLE : </span>Right &amp; left eye
                </p>
              </li>
              <li>
                <p>
                  <span className="bold">- FV : </span>Far vision
                </p>
              </li>
              <li>
                <p>
                  <span className="bold">- NV : </span>Near vision
                </p>
              </li>
              <li>
                <p>
                  <span className="bold">- ADD : </span>Addition
                </p>
              </li>
              <li>
                <p>
                  <span className="bold">- SPH : </span>Sphere
                </p>
              </li>
              <li>
                <p>
                  <span className="bold">- CYL : </span>Cylinder
                </p>
              </li>
              <li>
                <p>
                  <span className="bold">- VI : </span>Intermediate Vision
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="prescription-step step-section section3">
        <div className="wrapper">
          <div className="column left">
            <Icon imgPath="/images/about/about-prescription-form-step2.png"></Icon>
          </div>
          <div className="column right">
            <h2>Our prescription form</h2>
            <p>
              Thanks to the four steps of our online service,{' '}
              <span className="bold">buying glasses has never been easier.</span> We take in
              consideration every scenario in order to offer you only the products adapted to your
              correction.
            </p>
            <ol>
              <li>
                <p>
                  <span className="bold">1. &nbsp;</span>CHOOSE YOUR FRAME &amp; LENSES
                </p>
              </li>
              <li>
                <p>
                  <span className="bold">2. &nbsp;</span>TYPE IN YOUR PRESCRIPTION
                </p>
              </li>
              <li>
                <p>
                  <span className="bold">3. &nbsp;</span>GO TO A KIOSK TO SCAN YOUR FACE
                </p>
              </li>
              <li>
                <p>
                  <span className="bold">4. &nbsp;</span>GET YOUR GLASSES
                </p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPrescription;
